import React from "react";
import wineImage from '../../images/vin.JPG';
import CategoryPage from '../CategoryPage';

function VinEtSpiritueuxPage() {
    const details = [
        "Château Margaux (Bordeaux) – Grand cru classé, réputé pour sa finesse et son potentiel de garde.",
        "Château Lafite Rothschild (Bordeaux) – L’un des plus prestigieux crus, recherché pour sa longévité exceptionnelle.",
        "Romanée-Conti (Bourgogne) – Le plus mythique des grands crus de la Côte de Nuits.",
        "Château Latour (Bordeaux) – Un des premiers grands crus classés de Pauillac, recherché pour sa puissance et son élégance.",
        "Pétrus (Bordeaux, Pomerol) – L’un des vins les plus prestigieux et rares au monde.",
        "Dom Pérignon (Champagne) – La cuvée emblématique de Moët & Chandon, un must-have pour les collectionneurs.",
        "Rémy Martin Louis XIII – Un des plus célèbres cognacs, prisé pour sa qualité exceptionnelle.",
        "Hennessy Paradis Impérial – Un cognac d’exception, vieilli plus de 130 ans, prisé pour sa douceur et sa finesse.",
    ];

    return (
        <CategoryPage
            title="Vin et Spiritueux"
            image={wineImage}
            description="Vous possédez des bouteilles de vin ou de spiritueux à vendre, même si elles ne sont plus consommables ? Nous rachetons toutes les bouteilles, y compris les grands crus. Que ce soit des vins de renom ou des spiritueux haut de gamme, chaque bouteille peut avoir sa valeur. Contactez-nous pour une estimation personnalisée."
            details={details}
        />
    );
}

export default VinEtSpiritueuxPage;
